import Checkbox from '../../../forms/Checkbox'
import { processedTypesInversed } from '@teinor/erp/types/company/order/general'
import { useState, useCallback, useMemo } from 'react'
import { UserPermissionsSingle } from '../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../baseComponents/PermissionChecker'
import { permissionCheck } from '../../../baseComponents/PermissionChecker/function'
import { InputTableLeftColumnChange } from '../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { CustomSelectProps, CustomSelectBase } from '../../../forms/CustomSelect'
import { CustomSelectSectionSearchbarDropDown } from '../../../forms/CustomSelect/CustomSelectSections'
import { DisplayTextFuncTy } from '../../../forms/CustomSelect/types'
import { OnSubmit } from '../../../forms/TwinForm/types'
import { TwinDictionary, dictionaryComplexFromJsonArr } from '../../../utils/globals/dictionary'
import useEditDeleteModal from '../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../utils/reducers/getters'
import { ModalCreateCustomerCampaignOutside } from '../../Customers/CustomerProfileTabs/CustomerCampaigns/ModalCreateCustomerCampaign'
import ModalEditCustomerProject from '../../Customers/ModalEditCustomerProject'
import ModalEditCampaignCustomer from '../../ModalEditCampaignCustomer'
import { ITCheckboxProps } from '../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { ModalCreateCustomerOpportunityOutside } from '../../Customers/CustomerProfileTabs/CustomerOpportunities/ModalCreateCustomerOpportunity'
import { projectTypesInversed } from '@teinor/erp/types/company/customer/customerProject'
import { faChartSimple, faFileSlash } from '@fortawesome/pro-light-svg-icons'
import { CustomSelectAndCreateSectionProjects } from '../../Customers/CustomSelectSectionProjects'
import { ModalCreateCustomerProjectOutside } from '../../Customers/ModalCreateCustomerProject'

interface SellSelectedCheckboxProps extends ITCheckboxProps {
    readOnlyFnc?: (allRowData: TwinDictionary) => boolean
}
export const SellSelectedCheckbox: React.FC<SellSelectedCheckboxProps> = ({ allRowData, value, onChange, readOnlyFnc }) => {
    const readOnly = (readOnlyFnc && readOnlyFnc?.(allRowData)) || false
    if ((readOnlyFnc && readOnly) || (!readOnlyFnc && allRowData.processed !== processedTypesInversed['unprocessed'])) {
        return null
    }
    return <Checkbox label={''} checked={value === true as any} onChange={onChange} />
}

interface WorkSheetCheckboxProps extends ITCheckboxProps {
}
export const WorkSheetCheckbox: React.FC<WorkSheetCheckboxProps> = ({ value, onChange }) => {
    return <Checkbox label={''} checked={value === true as any} onChange={onChange} />
}
interface SellRefundCheckboxProps extends ITCheckboxProps {
}
export const SellRefundCheckbox: React.FC<SellRefundCheckboxProps> = ({ allRowData, value, onChange }) => {
    if (allRowData.totalRefund) {
        return null
    }
    return <Checkbox label={''} checked={value === true as any} onChange={onChange} />
}


type CustomSellSelectProjectProps = & CustomeSellSelectLogicProps & {
    classNameField?: string
    orderByOpp?: true
    name?: string
    setLockOnClickOut?: (lock: boolean) => void
    viewLabel?: boolean
}

export const CustomSellSelectProject: React.FC<CustomSellSelectProjectProps> = ({ headerData, handleChange, items, getCompleteData, classNameField, orderByOpp, setLockOnClickOut, viewLabel = true,...rest }) => {
    const { openModal, setOpenModal, customerProjectId, myOnChange, userPermissions, myOnSubmit, translations, extraMainSections } = useCustomeSellSelectProjectLogic({ headerData, handleChange, items, getCompleteData })
    return (
        <PermissionChecker userPermissions={userPermissions} permission={'update'} >
            <div className={'flex flex-col custom_sell_select_project ' + (classNameField || '')}>
                <CustomSelectAndCreateSectionProjects projects={items} onChange={(value) => myOnChange(value)} sortItems={true} value={customerProjectId} extraMainSections={extraMainSections} orderByOpp={orderByOpp} {...rest} />
                {customerProjectId && viewLabel ?
                    <div className='ml-auto mt-4 text-12 cursor-pointer custom_select_see_project_text' onClick={() => setOpenModal({ type: 'edit', allRowData: {} })}>{translations}</div>
                    : null}
                {openModal?.type === 'edit' && <ModalEditCustomerProject setOpened={() => setOpenModal(null)} onSubmit={() => {}} userPermissions={userPermissions || { n: 4, permission: 'delete' }} allRowData={{ id: customerProjectId }} basicData={{}} />}
                {openModal?.type === 'create' && <ModalCreateCustomerProjectOutside setOpened={() => setOpenModal(null)} onSubmit={myOnSubmit} userPermissions={userPermissions || { n: 4, permission: 'delete' }} basicData={{ CustomerId: headerData?.CustomerId }} setLockOnClickOut={setLockOnClickOut} />}
                {openModal?.type === 'delete' && <ModalCreateCustomerOpportunityOutside setOpened={() => setOpenModal(null)} onSubmit={myOnSubmit} userPermissions={userPermissions || { n: 4, permission: 'delete' }} basicData={{ CustomerId: headerData?.CustomerId }} setLockOnClickOut={setLockOnClickOut} />}
            </div>
        </PermissionChecker>
    )
}

interface CustomeSellSelectLogicProps {
    headerData: TwinDictionary
    handleChange: InputTableLeftColumnChange
    items: TwinDictionary[];
    getCompleteData: () => void
}

const useCustomeSellSelectProjectLogic = ({ headerData, handleChange, items, getCompleteData }: CustomeSellSelectLogicProps) => {
    const { t } = useTwinTranslation()
    const dictCustomerProjects = useMemo(() => dictionaryComplexFromJsonArr(items), [items])
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [customerProjectId, setCustomerProjectId] = useState<number | string>(headerData?.CustomerProjectId)
    
    const buttonTrans = t('seeProject', 'Ver proyecto')
    const buttonTrans2 = t('seeOppS', 'Ver oport.')
    const unassignTrans = t('unassign', 'Desasignar')
    const userPermissions = getUserPermissions(['customer.profile.projects', 'customer.projects.main']) || { n: 1, permission: 'read' }
    const extraMainSections: TwinDictionary[] = [{ text: unassignTrans, value: '', hiddenText: unassignTrans, icon: faFileSlash, className: 'section_items_background' }]
    const id = headerData?.id
    const myOnChange = useCallback((value: number) => {
        let myValue: number | '' = value
        if (value === 0) {
            myValue = ''
            setOpenModal({ type: 'create', allRowData: {} })
        }
        if (value === -1) {
            myValue = ''
            setOpenModal({ type: 'delete', allRowData: {} })
        }
        setCustomerProjectId(myValue)
        handleChange(id, 'CustomerProjectId', myValue)
    }, [handleChange, setCustomerProjectId, id, setOpenModal])

    const myOnSubmit: OnSubmit = useCallback(async (e) => {
        const result = await e.json()
        if (result) {
            await getCompleteData()
            handleChange(id, 'CustomerProjectId', result.id)
            setCustomerProjectId(result.id)
        }
    }, [getCompleteData, handleChange, setCustomerProjectId, id])

    const translations = useMemo(() => {
        const projectType = dictCustomerProjects[customerProjectId]?.projectType
        let buttonText = buttonTrans
        if (projectType || projectType === 0) {
            if (projectType === projectTypesInversed['opportunity']) {
                buttonText = buttonTrans2
            }
        }
        return buttonText
    }, [customerProjectId, dictCustomerProjects, buttonTrans, buttonTrans2])

    return { openModal, setOpenModal, customerProjectId, myOnChange, userPermissions, extraMainSections, myOnSubmit, translations }
}

type CustomSellSelectCampaignProps = & CustomSelectProps & CustomeSellSelectLogicProps & {
    classNameField?: string
    setLockOnClickOut?: (lock: boolean) => void
    viewLabel?: boolean
}

export const CustomSellSelectCampaign: React.FC<CustomSellSelectCampaignProps> = ({ label, headerData, handleChange, items, getCompleteData, classNameField, setLockOnClickOut, viewLabel = true, ...rest }) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal, customerCampaignId, myOnChange, parsedSectionItems, userPermissions, displayTextFunc, myOnSubmit } = useCustomSellSelectCampaignLogic({ headerData, handleChange, items, getCompleteData })
    return (
        <PermissionChecker userPermissions={userPermissions} permission={'update'} >
            <div className={'flex flex-col custom_sell_select_campaign ' + (classNameField || '')}>
                <CustomSelectBase label={label} onChange={(value) => myOnChange(value)} {...rest} items={parsedSectionItems} sortItems={true} value={customerCampaignId} DropDownComponent={CustomSelectSectionSearchbarDropDown} displayTextFunc={displayTextFunc} />
                {customerCampaignId && viewLabel ?
                    <div className='ml-auto mt-4 text-12 custom_select_see_campaign_text cursor-pointer' onClick={() => setOpenModal({ type: 'edit', allRowData: {} })}>{t('seeCampaign2', 'Ver campaña')}</div>
                    : null}
                {openModal?.type === 'edit' && <ModalEditCampaignCustomer setOpened={() => setOpenModal(null)} onSubmit={() => { }} userPermissions={userPermissions || { n: 4, permission: 'delete' }} allRowData={{ id: customerCampaignId }} basicData={{}} />}
                {openModal?.type === 'create' && <ModalCreateCustomerCampaignOutside setOpened={() => setOpenModal(null)} onSubmit={myOnSubmit} userPermissions={userPermissions || { n: 4, permission: 'delete' }} basicData={{ CustomerId: headerData?.CustomerId }} setLockOnClickOut={setLockOnClickOut} />}
            </div>
        </PermissionChecker>
    )
}

const useCustomSellSelectCampaignLogic = ({ headerData, handleChange, items, getCompleteData }: CustomeSellSelectLogicProps) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [customerCampaignId, setCustomerCampaignId] = useState<number | string>(headerData?.CampaignCustomerId)
    const othersTrans = t('actions', 'Acciones')
    const mainOtherTrans = t('addCampaign', 'Añadir campaña')
    const userPermissions = getUserPermissions(['customer.profile.campaign', 'customer.campaigns.inner']) || { n: 1, permission: 'read' }
    const sectionItems: TwinDictionary[] = [{ value: "", text: 'Campañas', isSection: true }, { text: '---', value: '' }, ...items]
    const mainSections: TwinDictionary[] = [{ value: 0, text: mainOtherTrans, hiddenText: mainOtherTrans, icon: faChartSimple, className: 'section_items_background' }]
    const { displayTextFunc, parsedSectionItems } = useCustomDropDownSelectSectionsLogic({ userPermissions, mainSections, items, othersTrans, sectionItems })
    const id = headerData?.id

    const myOnChange = useCallback((value: number) => {
        let myValue: number | '' = value
        if (value === 0) {
            myValue = ''
            setOpenModal({ type: 'create', allRowData: {} })
        }
        handleChange(id, 'CampaignCustomerId', myValue)
        setCustomerCampaignId(myValue)
    }, [handleChange, setCustomerCampaignId, id, setOpenModal])

    const myOnSubmit: OnSubmit = useCallback(async (e) => {
        const result = await e.json()
        if (result) {
            getCompleteData()
            handleChange(id, 'CampaignCustomerId', result.id)
            setCustomerCampaignId(result.id)
        }
    }, [getCompleteData, handleChange, setCustomerCampaignId, id])

    return { openModal, setOpenModal, customerCampaignId, myOnChange, userPermissions, displayTextFunc, parsedSectionItems, myOnSubmit }
}

interface CustomDropDownSelectSectionsLogicProps {
    userPermissions: UserPermissionsSingle
    items: TwinDictionary
    sectionItems: TwinDictionary[]
    mainSections: TwinDictionary[],
    othersTrans: string
}

const useCustomDropDownSelectSectionsLogic = ({ userPermissions, items, sectionItems, othersTrans, mainSections }: CustomDropDownSelectSectionsLogicProps) => {
    const displayTextFunc: DisplayTextFuncTy = useCallback((_items, value) => {
        const indexSections = dictionaryComplexFromJsonArr(items)
        return indexSections[value]?.name
    }, [items])

    const parsedSectionItems = useMemo(() => {
        if (permissionCheck(userPermissions, 'create')) {
            sectionItems.splice(0, 0, ...mainSections)
            sectionItems.splice(0, 0, { value: "", text: othersTrans, isSection: true })
        }
        return sectionItems
    }, [othersTrans, mainSections, userPermissions, sectionItems])
    return { displayTextFunc, parsedSectionItems }
}